/**
 * Job Card — Accordion toggle + filtro por área/cargo
 */

export function initJobCard() {
  const toggleButtons = document.querySelectorAll('.js-job-card-toggle');

  toggleButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const card = btn.closest('.job-card');
      if (!card) return;

      // Fecha os outros cards abertos
      document.querySelectorAll('.job-card.is-active').forEach((activeCard) => {
        if (activeCard !== card) {
          activeCard.classList.remove('is-active');
        }
      });

      // Toggle do card atual
      card.classList.toggle('is-active');
    });
  });

  // Clique no header também abre/fecha
  const headers = document.querySelectorAll('.job-card__header');
  headers.forEach((header) => {
    header.addEventListener('click', (e) => {
      // Não ativar se clicou num link ou botão que não seja o toggle
      if (e.target.closest('.job-card__btn-candidatar') || e.target.closest('.job-card__btn-arrow')) return;

      const card = header.closest('.job-card');
      if (!card) return;

      document.querySelectorAll('.job-card.is-active').forEach((activeCard) => {
        if (activeCard !== card) {
          activeCard.classList.remove('is-active');
        }
      });

      card.classList.toggle('is-active');
    });
  });

  // Filtro de vagas
  initJobFilter();
}

function initJobFilter() {
  const areaSelect = document.querySelector('[name="area"]');
  const cargoSelect = document.querySelector('[name="cargo"]');

  if (!areaSelect && !cargoSelect) return;

  function filterCards() {
    const areaValue = areaSelect ? areaSelect.value : '';
    const cargoValue = cargoSelect ? cargoSelect.value : '';
    const cards = document.querySelectorAll('.job-card[data-area], .job-card[data-cargo]');

    cards.forEach((card) => {
      const cardArea = card.dataset.area || '';
      const cardCargo = card.dataset.cargo || '';

      let show = true;

      if (areaValue && cardArea && cardArea !== areaValue) {
        show = false;
      }

      if (cargoValue && cardCargo && cardCargo !== cargoValue) {
        show = false;
      }

      card.style.display = show ? '' : 'none';
    });
  }

  if (areaSelect) areaSelect.addEventListener('change', filterCards);
  if (cargoSelect) cargoSelect.addEventListener('change', filterCards);
}
